module.exports = __webpack_public_path__ + "static/media/a-4-b.10b60e83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-4-b.jpg
// module id = 1101
// module chunks = 33